import { Component, Inject, Input, OnDestroy } from '@angular/core';
import { ApplicationFacade, CardsNgrxFacade, CustomerCard, CustomerCardType } from '@ridango/components';
import { AllowedPathService, AppStartupService, BaseComponent } from '@ridango/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CardBlockModalComponent } from '../card-block-modal/card-block-modal.component';
import { CardRemoveModalComponent } from '../card-remove-modal/card-remove-modal.component';
import { IonModal, IonPopover } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import Env from '@ridango/core/env';
import { CardsPurchaseFacadeService } from '../../../../services/cards/cards-purchase.facade.service';
import { PersonalizationStatus } from '../../../../enums/personalization-status.enum';

@Component({
    selector: 'rwidget-cards-list-item',
    templateUrl: './cards-list-item.component.html',
    styleUrls: ['./cards-list-item.component.scss']
})
export class CardsListItemComponent extends BaseComponent implements OnDestroy {
    @Input() card: CustomerCard;

    readonly cardType = CustomerCardType;
    readonly personalizationStatus = PersonalizationStatus;

    readonly assetsPath$ = this.applicationFacade.assetsPath$;
    readonly isWebPurchaseAllowed = this.pathService.isWebPurchaseAllowed();

    constructor(
        private applicationFacade: ApplicationFacade,
        public appStartupService: AppStartupService,
        private router: Router,
        private route: ActivatedRoute,
        private translate: TranslateService,
        @Inject('ENV') public env: Env,
        private pathService: AllowedPathService,
        private cardsFacade: CardsNgrxFacade,
        private cardsPurchaseFacadeService: CardsPurchaseFacadeService
    ) {
        super();
    }

    navigateToPurchaseFlow(contextualMenu: IonModal | IonPopover) {
        contextualMenu.dismiss().then(() => {
            this.cardsPurchaseFacadeService.navigateToPurchaseFlow(this.env, this.card);
        });
    }

    navigateToDetailsView() {
        this.router.navigate([`${this.card.id}/details`], { relativeTo: this.route.parent });
    }

    navigateToEditView(contextualMenu: IonModal | IonPopover) {
        contextualMenu.dismiss().then(() => {
            this.router.navigate([`${this.card?.relatedCardId}/edit`], { relativeTo: this.route.parent });
        });
    }

    unblockCard(contextualMenu: IonModal | IonPopover) {
        contextualMenu.dismiss().then(() => {
            this.cardsFacade.unblockCard(this.card);
        });
    }

    scrollToCard(card: HTMLDivElement) {
        card.scrollIntoView({ behavior: 'smooth' });
    }

    openRemoveModal(removeCardModal: CardRemoveModalComponent, contextualMenu: IonModal | IonPopover) {
        contextualMenu.dismiss().then(() => removeCardModal.openModal(this.card));
    }

    openBlockModal(blockCardModal: CardBlockModalComponent, contextualMenu: IonModal | IonPopover) {
        contextualMenu.dismiss().then(() => blockCardModal.openModal(this.card));
    }

    navigateToCardWallet(contextualMenu?: IonModal | IonPopover): void {
        const queryParams = this.card?.cardNumber ? { cardNumber: this.card.cardNumber } : {};
        if (contextualMenu) {
            contextualMenu.dismiss().then(() => {
                this.router.navigate([this.translate.currentLang, 'purchase', 'wallet'], { queryParams });
            });
        } else {
            this.router.navigate([this.translate.currentLang, 'purchase', 'wallet'], { queryParams });
        }
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }
}
